import { gql } from '@apollo/client';

/**
 * 按运单号查询订单收件地址在 order_address 里的原始地址与标准化结果（排查用）。
 *
 * 查单口径与 PDA 扫描一致：内部运单号 / 渠道订单号 / 外部运单号任一命中。
 * 订单不存在返回 null；订单存在但收件地址缺失时返回订单信息、地址字段为 null。
 */
export const GET_ORDER_STANDARDIZED_ADDRESS = gql`
  query GetOrderStandardizedAddress($trackingNumber: String!) {
    getOrderStandardizedAddress(trackingNumber: $trackingNumber) {
      orderId
      trackingNumber
      orderAddressId
      originalStreetAddress
      originalBuilding
      originalCity
      originalState
      originalPostalCode
      addressCoreId
      standardizedAddress
      latitude
      longitude
    }
  }
`;

export interface OrderStandardizedAddressType {
  orderId: number;
  trackingNumber: string | null;
  /** 收件地址 ID（order_address.id）；订单无收件地址时为 null */
  orderAddressId: number | null;
  /** 原始街道信息 */
  originalStreetAddress: string | null;
  /** 原始地址行 2 */
  originalBuilding: string | null;
  originalCity: string | null;
  originalState: string | null;
  originalPostalCode: string | null;
  /** 标准化地址 ID（order_address.address_core_id）；未标准化时为 null */
  addressCoreId: number | null;
  /** 标准化地址全文；未标准化时为 null */
  standardizedAddress: string | null;
  latitude: string | null;
  longitude: string | null;
}

export interface GetOrderStandardizedAddressResponse {
  getOrderStandardizedAddress: OrderStandardizedAddressType | null;
}
